import { buildUsersDashboardEmailAssistantQueryContext } from "./EmailAssistantManualUsersDashboardQueryContextModel";
import {
  buildOrganisationProfileEmailAssistantQueryContext,
  buildOrganisationsDashboardEmailAssistantQueryContext,
} from "./EmailAssistantOrganisationQueryContextModel";
import {
  buildPartnerProfileEmailAssistantQueryContext,
  buildPartnersDashboardEmailAssistantQueryContext,
} from "./EmailAssistantPartnerQueryContextModel";
import type { EmailAssistantQueryContext } from "./EmailAssistantQueryContextTypes";

export const buildManualEmailAssistantQueryContext = (
  searchParams: URLSearchParams,
): EmailAssistantQueryContext | null => {
  const safeSource = searchParams.get("eaSafeSource");
  const selectedCount = searchParams.get("eaSelectedCount");

  if (safeSource === "organisation_profile") {
    return buildOrganisationProfileEmailAssistantQueryContext(searchParams);
  }

  if (safeSource === "dashboard_bulk_organisations") {
    return buildOrganisationsDashboardEmailAssistantQueryContext(
      searchParams,
      selectedCount,
    );
  }

  if (safeSource === "dashboard_bulk_users") {
    return buildUsersDashboardEmailAssistantQueryContext(searchParams);
  }

  if (safeSource === "partner_profile") {
    return buildPartnerProfileEmailAssistantQueryContext(searchParams);
  }

  if (safeSource === "dashboard_bulk_partners") {
    return buildPartnersDashboardEmailAssistantQueryContext(
      searchParams,
      selectedCount,
    );
  }

  return null;
};
